/// <reference types="./when.d.mts" />
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $element from "../../lustre/lustre/element.mjs";
import { Ok } from "../gleam.mjs";

export function some(opt, next) {
  if (opt instanceof $option.Some) {
    let opt$1 = opt[0];
    return next(opt$1);
  } else {
    return $element.none();
  }
}

export function ok(res, next) {
  if (res instanceof Ok) {
    let res$1 = res[0];
    return next(res$1);
  } else {
    return $element.none();
  }
}

export function true$(res, next) {
  if (res) {
    return next();
  } else {
    return $element.none();
  }
}

export function false$(res, next) {
  if (res) {
    return $element.none();
  } else {
    return next();
  }
}
